import { useField, Field } from 'vee-validate';
import TooltipButton from '../TooltipButton.vue';


export default {
  __name: 'YourRoleInWork',
  props: {
    isRequired: {
        type: Boolean,
        default: true,
    },
    title: {
        type: String,
        default: 'Czym zajmujesz się w pracy?',
    },
    placeholder: {
        type: String,
        default:
            'Wpisz rodzaj wykonywanej pracy / obowiązki zawodowe',
    },
    classes: {
        type: String,
        default: '',
    },
},
  setup(__props, { expose }) {
  expose();

const props = __props;



const { value, errors, errorMessage } = useField('yourRoleInWork');

const __returned__ = { props, value, errors, errorMessage, get useField() { return useField }, get Field() { return Field }, TooltipButton }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}